import { getUrlParameterByName, getRegionByCountryCode, objectArrayToObject, arrayFromObj, decodePriceListDetails, decodeRequestIsFor, getAllEnabledCountries } from './../utils/utility';
import countries from './../libs/countries.json';
import appImageReferences from './../libs/app-images-references.json';
import AppConfigData from './../libs/app-config.json';
import { orderAppliesToCurrentUser } from './../libs/data-transform';

export const LANG = getUrlParameterByName("languageCode") ? getUrlParameterByName("languageCode").toLowerCase() : "en";
export const ENABLED_COUNTRIES = getAllEnabledCountries();//Todo - change this to local based when possible
export const COUNTRY_CODE = getUrlParameterByName("countryCode") ? (ENABLED_COUNTRIES.includes(getUrlParameterByName("countryCode").toUpperCase()) ? getUrlParameterByName("countryCode").toUpperCase() : "US") : "US";
export const COUNTRY_INFO = countries.list.filter(country => country.id === COUNTRY_CODE)[0];
export const REGION_CODE = getRegionByCountryCode(COUNTRY_CODE) || "AMS";
export const STATES_LIST = objectArrayToObject(countries.list, "id", "states")[COUNTRY_CODE] || [];
export const DEFAULT_STATE_INFO = (STATES_LIST && STATES_LIST.length > 0) ? { id: "NO_VALUE", label: "", postal_code_prefixes: [] } : null;
export const LOCALE = LANG + "-" + COUNTRY_CODE;
export const TIME_ZONE = "";
export const USER_ID = getUrlParameterByName("id");
export const HOST = window.location.protocol + "//" + window.location.host;
export const BUSINESS_LANDING = getUrlParameterByName("landing") ? getUrlParameterByName("landing").toLowerCase() !== "consumer" : true;
export const RECYCLING_OPTIONS_AVAILABLE = arrayFromObj(AppConfigData.order_options).map(o => orderAppliesToCurrentUser(o.value)).filter(a => a).length > 0;

const pathNames = window.location.pathname.split("/");
const apiEndPointPath = "/api/route";
export const SERVICES_BASE_URL = pathNames[1] && pathNames[1] !== "ui" ? HOST + "/" + pathNames[1] + apiEndPointPath : HOST + apiEndPointPath;

export const IS_PRE_LOGIN = window.location.hash.indexOf("prelogin") !== -1;

const requestIsFor = decodeRequestIsFor();
const priceListDetails = decodePriceListDetails();
export const IS_SURVEY_RESPONSE = requestIsFor === "SURVEY";
export const IS_UAM_TEAM_INVITE = requestIsFor === "UAM_TEAM_INVITE";
export const IS_PRICE_LIST_APPROVAL = requestIsFor === "PRICE_LIST_APPROVAL";
export const PRICE_LIST_DETAILS = { ...priceListDetails };
export const AUTHORIZATION_SERVICE_URL = "/authorization/";
export const CATALOG_SERVICE_URL = "/catalog/";
export const FAQ_SERVICE_URL = "/content/";
export const ORDER_SERVICE_URL = "/order";
export const REPORTS_SERVICE_URL = "/reports/";
export const REPORT_SERVICE_URL = "/report/";
export const SURVEYS_SERVICE_URL = "/survey/";
export const USERPROFILE_SERVICE_URL = "/userprofile/";
export const QUOTE_SERVICE_URL = "/quote";
export const PAYMENT_SERVICE_URL = "/payment";
export const DEAL_SERVICE_URL = "/deal";
export const QUOTE_DEAL_SERVICE_URL = "/quote/deal";
export const CHECK_QUOTE_DEAL_SERVICE_URL = "quote/deal/validateDealRequest";
export const CUSTOMERENTITY_SERVICE_URL = "/customer";
export const DELETE_VENDOR_PRICES = "/quote/deleteVendorPrices";
export const AUTOMATIC_FOLLOW_UP = "/quote/setVendorPriceFollowUpFlag";
export const DRSCUSTOMER_SERVICE_URL = "/quote";

export const DEFAULT_FORM_FIELDS_MAX_LENGTH = 50;

export const CATEGORY_IMAGES = appImageReferences.catalog.categories;
export const SHIPPING_MATERIAL_IMAGES = appImageReferences.catalog.materials;
export const SERVICES_IMAGES = appImageReferences.catalog.services;
export const TOOLTIP_HELP_IMAGES = appImageReferences.catalog.tooltipHelp;
export const RECYCLING_OPTIONS_IMAGE = appImageReferences.recyclingOptions;
export const GENERAL_IMAGES = appImageReferences.general;

export const FETCH_TYPE_HEADER_NAME = "HW-Fetch-Type";

export const TEST_ENVIRONMENT = window.location.href.indexOf("uat") !== -1 || window.location.href.indexOf("perf") !== -1 || window.location.href.indexOf("localhost") !== -1;
export const COD_TEST_MODE = TEST_ENVIRONMENT && !!getUrlParameterByName("codTest");
export const REDIRECT_HP2B = "https://uat-device-recovery.ext.hp.com/api/route/order/redirect";